// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-ProfileHeader-styles--root--AEOkf {
  display: none;
  flex-shrink: 0;
  margin-bottom: 1px;
  padding: 15px 10px;
  background-color: #fff;
  background-color: var(--mainBackground);
}

@media screen and (min-width: 768px) {

.src-components-ProfileHeader-styles--root--AEOkf {
    border-bottom: solid 1px #e8eaf0;
    border-bottom: solid 1px var(--lightGrayBlue);
    display: block;
    padding: 30px 20px;
}
  }

@media screen and (min-width: 1024px) {

.src-components-ProfileHeader-styles--root--AEOkf {
    padding-left: 25px;
    padding-right: 25px;
}
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/ProfileHeader/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAuC;EAAvC,uCAAuC;AAYzC;;AAVE;;AAPF;IAQI,gCAA6C;IAA7C,6CAA6C;IAC7C,cAAc;IACd,kBAAkB;AAOtB;EANE;;AAEA;;AAbF;IAcI,kBAAkB;IAClB,mBAAmB;AAEvB;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  display: none;\n  flex-shrink: 0;\n  margin-bottom: 1px;\n  padding: 15px 10px;\n  background-color: var(--mainBackground);\n\n  @media (--desktop) {\n    border-bottom: solid 1px var(--lightGrayBlue);\n    display: block;\n    padding: 30px 20px;\n  }\n\n  @media (--desktop-l) {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-ProfileHeader-styles--root--AEOkf`
};
module.exports = ___CSS_LOADER_EXPORT___;
